import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('DE');
    const [translations, setTranslations] = useState({});

    useEffect(() => {
        // Dynamisch die richtige Sprachdatei laden
        import(`../locales/${language.toLowerCase()}.json`)
            .then(module => {
                setTranslations(module.default || module);
            })
            .catch(() => {
                console.error(`Failed to load language file for ${language}`);
                // Fallback auf Englisch
                import('../locales/en.json')
                    .then(module => setTranslations(module.default || module));
            });
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, translations }}>
            {children}
        </LanguageContext.Provider>
    );
};